import {Entity} from "./entity";
import {deserialize, deserializeAs, inheritSerialization} from "cerialize";

@inheritSerialization(Entity)
export class ProjetTravaux extends Entity {

  @deserializeAs('nom_scenario')
  nomScenario: string = null;

  @deserializeAs('logement_adresse')
  logementAdresse: string = null;

  @deserializeAs('logement_dpe')
  logementDPE: string = null;

  @deserializeAs('logement_localisation')
  logementLocalisation: string = null;

  @deserializeAs('logement_superficie_habitable')
  logementSuperficieHabitable: number = null;

  @deserializeAs('logement_type_bien')
  logementTypeBien: string = null;

  @deserializeAs('fenetre_type_vitrage')
  fenetreTypeVitrage: string = null;

  @deserializeAs('fenetre_air_passage')
  fenetreAirPassage: boolean = null;

  @deserializeAs('fenetre_age')
  fenetreAge: string = null;

  @deserializeAs('fenetre_modifier_facade')
  fenetreModifierFacade: boolean = null;

  @deserializeAs('type_toiture')
  typeToiture: string = null;

  @deserializeAs('type_combles')
  typeCombles: string = null;

  @deserializeAs('toiture_isolee')
  toitureIsolee: string = null;

  @deserializeAs('toiture_etat_isolation')
  toitureEtatIsolation: string = null;

  @deserializeAs('toiture_age_isolation')
  toitureAgeIsolation: string = null;

  @deserializeAs('planchertype_adjacence')
  planchertypeAdjacence: string = null;

  @deserializeAs('plancher_sous_face_accessible')
  plancherSousFaceAccessible: boolean = null;

  @deserializeAs('plancher_isole')
  plancherIsole: string = null;

  @deserializeAs('etat_isolation_plancher')
  etatIsolationPlancher: string = null;

  @deserializeAs('type_equipement_chauffage')
  typeEquipementChauffage: string = null;

  @deserializeAs('age_chauffage')
  ageChauffage: string = null;

  @deserializeAs('fonctionnement_chauffage')
  fonctionnementChauffage: boolean = null;

  @deserializeAs('type_energie_ecs')
  typeEnergieEcs: string = null;

  @deserializeAs('type_equipement_ecs')
  typeEquipementEcs: string = null;

  @deserializeAs('age_ecs')
  ageEcs: string = null;

  @deserializeAs('created_at')
  createdAt: Date;

  @deserializeAs('fonctionnement_ecs')
  fonctionnementEcs: boolean = null;

  @deserializeAs('presence_systeme_climatisation')
  presenceSystemeClimatisation: boolean = null;

  @deserializeAs('demande_climatisation')
  demandeClimatisation: boolean = null;

  @deserializeAs('age_climatisation')
  ageClimatisation: string = null;

  @deserializeAs('fonctionnement_climatisation')
  fonctionnementClimatisation: boolean = null;

  @deserialize
  logement = null;

  @deserializeAs('consommation_energie_before')
  consommationEnergieBefore: number = null;

  @deserializeAs('consommation_energie_label_before')
  consommationEnergieLabelBefore: string = null;

  @deserializeAs('emission_ges_before')
  emissionGesBefore: number = null;

  @deserializeAs('emission_ges_label_before')
  emissionGesLabelBefore: string = null;

  @deserializeAs('consommation_energie')
  consommationEnergie: number = null;

  @deserializeAs('consommation_energie_label')
  consommationEnergieLabel: string = null;

  @deserializeAs('emission_ges')
  emissionGes: number = null;

  @deserializeAs('emission_ges_label')
  emissionGesLabel: string = null;

  @deserializeAs('type_ventilation')
  typeVentilation;

  @deserializeAs('verification_humidite_ventilation')
  verificationHumiditeVentilation;

  @deserializeAs('age_ventilation')
  ageVentilation;

  @deserializeAs('presence_entrees_air_ventilation')
  presenceEntreesAirVentilation;

  @deserializeAs('preconisation_projet_travaux_ids')
  preconisationProjetTravauxIds;

  @deserializeAs('periode_construction_dpe')
  periodeConstructionDpe;

  @deserializeAs('type_installation_chauffage')
  typeInstallationChauffage;

  @deserializeAs('type_generateur_chauffage')
  typeGenerateurChauffage;

  @deserializeAs('type_energie_chauffage_appoint')
  typeEnergieChauffageAppoint;

  @deserializeAs('chauffage_solaire')
  chauffageSolaire;

  @deserializeAs('nb_generateur_chauffage')
  nbGenerateurChauffage;

  @deserializeAs('type_generateur_climatisation')
  typeGenerateurClimatisation;

  @deserializeAs('type_installation_ecs')
  typeInstallationEcs;

  @deserializeAs('ecs_solaire')
  ecsSolaire;

  @deserializeAs('nb_generateur_ecs')
  nbGenerateurEcs;

  @deserializeAs('type_production_energie_renouvelable')
  typeProductionEnergieRenouvelable;

  @deserializeAs('type_materiaux_menuiserie')
  typeMateriauxMenuiserie;

  @deserializeAs('type_gaz_lame')
  typeGazLame;

  @deserializeAs('type_fermeture')
  typeFermeture;

  @deserializeAs('traversant')
  traversant;

  @deserializeAs('zone_climatique')
  zoneClimatique;

  @deserializeAs('materiaux_facade')
  materiauxFacade;

  @deserializeAs('type_isolation_logement')
  typeIsolationLogement;

  @deserializeAs('etat_isolation')
  etatIsolation;

  @deserializeAs('modifier_espace_exterieur')
  modifierEspaceExterieur;

  @deserializeAs('age_isolation')
  ageIsolation;

  @deserializeAs('logement_etat_isolation')
  logementEtatIsolation;
}
